import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Te levantás con ardor antes de desayunar y ya sabés cómo va a terminar el día.', 'Comés algo "sano" y el reflujo aparece igual.', 'El omeprazol está en tu mesita de luz hace años y cada vez que intentás dejarlo, el fuego vuelve peor.', 'Te dijeron "es estrés", "es la edad" pero nadie explicó por qué sigue pasando.', 'Dejaste de disfrutar el asado y el mate por miedo a lo que viene después.', 'Gastaste en médicos y suplementos que solo te dieron alivio por días.'];
  return <section className="py-24 bg-brand-black relative overflow-hidden" data-id="element-154">
      {/* Subtle background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-red-900/5 to-transparent pointer-events-none" data-id="element-155" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-156">
        <div className="max-w-4xl mx-auto" data-id="element-157">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-158">
            <h2 className="md:text-5xl font-bold mb-6 font-[Poppins,_sans-serif] text-[24px]" data-id="element-159">
              ¿Cuánto tiempo más vas a esperar para comer sin miedo?
            </h2>
            <p className="text-gray-300 mb-4 text-[19px]" data-id="element-160">
              Sos una mujer que se cuida. Buscás soluciones y tomás en serio tu
              salud.
            </p>
            <p className="text-gray-300 mb-4 text-[19px]" data-id="element-161">
              Pero hasta ahora, nadie te dio la hoja de ruta correcta para tu
              cuerpo.
            </p>
            <p className="text-xl text-brand-light font-medium" data-id="element-162">
              No es falta de voluntad. Es que te faltaba el sistema correcto.
            </p>
          </motion.div>

          <div className="grid gap-4 md:gap-6 mb-16" data-id="element-163">
            {points.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-[#2a0a0a] p-5 rounded-xl border border-red-900/80" data-id="element-164">
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-165" />
                <p className="text-lg text-gray-200" data-id="element-166">{point}</p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="text-center" data-id="element-167">
            <h3 className="text-2xl md:text-4xl font-bold text-brand-gold italic font-[Inter,_sans-serif]" data-id="element-168">
              ¿Y si pudieras dejar de sentirte así a partir de hoy mismo?
            </h3>
          </motion.div>
        </div>
      </div>
    </section>;
}